<template>
<div class="pricing-table"> 
    <div v-if="compact" class="close-plans"  title="Cerrar Popup" @click="showHidePlansOptions()"><i class="las la-times-circle"></i></div>

    <div v-if="!this.isRegister" class="card card-plan text-center card-sms-plan">
        <div v-show="hideLoading" class="">
            <div class="d-flex justify-content-center align-items-center h-100 w-100 screen-waiting">
                <div>
                    <img src="@/assets/imgs/spinner-white.webp" class="img-fluid w-25">   
                </div>
            </div>
            <h4 class="text-center m-0 fw-normal">Cargando información de tu plan.</h4>
        </div>
        <section v-if="!hideLoading" class="text-center text-white fs-4">   
            <img src="@/assets/imgs/smile-white-animasana.svg" style="width:50px">
        </section> 
        <div v-if="!hideLoading" class="">
            <h4  class="text-center m-0 fw-normal" v-html="titleMessage"></h4>        
            <section v-if="couponBool && userPlan != 4" class="text-center text-white fs-5 mt-2">
                <p>Se aplicará un descuento de {{couponDiscount}}% por {{ couponMonth }} meses al valor de tu plan.<br> Finaliza la promoción el {{ couponFinishDate }}</p>
            </section> 
            <div class="mt-3 pay-content-btn">
                <div v-if="!periodFree">
                    <p class="m-0" v-if="userPlan == 4 && !selectPlanBool">El período vence el {{periodEndUser}}</p>
                    <p class="m-0" v-if="userPlan == 4 && selectPlanBool">El período de prueba finalizó el {{periodEndUser}}</p>
                    <div v-if="userPlanDuration == '30'">
                        <p class="m-0" v-if="userPlan != 4"><i class="las la-angle-double-right"></i> Período desde {{periodStartUser}} hasta el {{periodEndUser}}</p>
                        <p class="m-0" v-if="userPlan != 4"><i class="las la-angle-double-right"></i> Tu Próximo ciclo se renueva el {{ periodStartUserNext }}</p>
                    </div>
                    <div v-if="userPlanDuration != '30' && planPayDate != '0000-00-00'">
                        <p class="m-0" v-if="userPlan != 4"><i class="las la-angle-double-right"></i> Período desde {{periodStartUser}} hasta el {{periodEndUser}}</p>
                        <p class="m-0" v-if="userPlan != 4"><i class="las la-angle-double-right"></i> Tu Próximo ciclo se renueva el {{ periodStartUserNext }}</p>
                    </div>
                    <h3 v-if="userPlan != 3">Reservas: {{ totalUses }}/{{ planUses }}</h3>
                    <h3 v-if="userPlan == 3">Reservas: {{ totalUses }}/Ilimitado</h3>
                    <h5 v-if="cardAdded == 0 && userPlan != 4 && userPlanDuration == '30'" class="text-danger"><b><i class="las la-exclamation-triangle"></i> Vincula una tarjeta</b></h5>
                    <div v-if="cardAdded == 0 && userPlan != 4 && userPlanDuration == '30'">
                        <card-form-mp v-if="userCountry == 5"></card-form-mp>
                        <card-form-st v-else></card-form-st>
                    </div> 
                    <div v-if="cardAdded == 0 && userPlan != 4 && userPlanDuration != '30'">
                        <h5 class="text-green"><i class="las la-exclamation-triangle"></i>Realiza el pago de tu plan para activarlo:</h5>
                        <paymment-plans v-if="difPayPlan" :difPayPlan="difPayPlan"></paymment-plans>
                    </div>    
                </div>
                <div v-else>
                    <h5>Prueba gratis de 30 días</h5>
                    <p>Quedan {{ freeTrialDays }} días para que finalice el período de prueba.</p>
                </div>
                <div v-if="blockUse">
                    <h5 class="text-danger"><b><i class="las la-exclamation-triangle"></i> Has llegado al límite de sesiones contratadas</b></h5>
                    
                    <p class="legend">Los usuarios no podrán contratarte ni podrás ofrecer citas hasta que no se renueve el ciclo mensual.</p>
                    <div v-if="stepChangePlan == 0">
                        <h6>¿Necesitas más sesiones?</h6>
                        <div class="list-group">
                            <button v-if="canSelectGift && userPlan == 1" type="button" class="list-group-item list-group-item-action" @click="giftSessions()">5 turnos más</button>
                            <button v-if="canSelectGift && userPlan == 2" type="button" class="list-group-item list-group-item-action" @click="giftSessions()">10 turnos más</button>  
                            <button type="button" class="list-group-item list-group-item-action" @click="stepChangePlan = 1">Cambiar de plan</button>    
                        </div>
                    </div>
                    <div v-if="stepChangePlan == 1">
                        <h6>Seleccionar un plan</h6>
                        <div class="mb-3 col-sm-12">
                            <div class="input-group mb-3">
                                <select class="form-control form-control-lg text-center" id="plan" v-model="planSelected">
                                    <optgroup label="Mensuales">
                                        <option 
                                        v-for="p in plans.filter(pl => pl.duration == 30 && pl.plan_id != 4)" 
                                        :key="p.id" 
                                        :value="p.id">
                                        Plan mensual {{ p.name }} - {{ p.currency }} {{ formatNumber(p.real_price) }}
                                        </option>
                                    </optgroup>

                                    <optgroup label="Semestrales">
                                        <option 
                                        v-for="p in plans.filter(pl => pl.duration == 180 && pl.plan_id != 4)" 
                                        :key="p.id" 
                                        :value="p.id">
                                        Plan semestral {{ p.name }} - {{ p.currency }} {{ formatNumber(p.real_price) }}
                                        </option>
                                    </optgroup>

                                    <optgroup label="Anuales">
                                        <option 
                                        v-for="p in plans.filter(pl => pl.duration == 365 && pl.plan_id != 4)" 
                                        :key="p.id" 
                                        :value="p.id">
                                        Plan anual {{ p.name }} - {{ p.currency }} {{ formatNumber(p.real_price) }}
                                        </option>
                                    </optgroup>
                                </select>  
                            </div>
                            <div class="d-flex w-100"> 
                                <button class="btn btn-secondary mx-auto m-2 mt-0 mb-0 d-inline-block w-50 p-0 pt-2 pb-2" @click="stepChangePlan = 0">Cancelar</button>
                                <div class="m-2 d-inline-block"></div>
                                <button class="btn btn-primary mx-auto m-2 mt-0 mb-0 d-inline-block w-50 p-0 pt-2 pb-2" @click="selectPlan(planSelected)">Seleccionar</button> 
                            </div>   
                        </div>
                    </div>
                </div>
                <div v-if="selectPlanBool"><h5><b>Selecciona el plan que mejor se adapte a ti</b></h5></div>
                <div v-if="userPlan == 4 && selectPlanBool">
                    <h6>Seleccionar un plan</h6>
                    <div class="mb-3 col-sm-12">
                        <div class="input-group mb-3">
                            <select class="form-control form-control-lg text-center" id="plan" v-model="planSelected">
                                <optgroup label="Mensuales">
                                    <option 
                                    v-for="p in plans.filter(pl => pl.duration == 30 && pl.plan_id != 4)" 
                                    :key="p.id" 
                                    :value="p.id">
                                    Plan mensual {{ p.name }} - {{ p.currency }} {{ formatNumber(p.real_price) }}
                                    </option>
                                </optgroup>

                                <optgroup label="Semestrales">
                                    <option 
                                    v-for="p in plans.filter(pl => pl.duration == 180 && pl.plan_id != 4)" 
                                    :key="p.id" 
                                    :value="p.id">
                                    Plan semestral {{ p.name }} - {{ p.currency }} {{ formatNumber(p.real_price) }}
                                    </option>
                                </optgroup>

                                <optgroup label="Anuales">
                                    <option 
                                    v-for="p in plans.filter(pl => pl.duration == 365 && pl.plan_id != 4)" 
                                    :key="p.id" 
                                    :value="p.id">
                                    Plan anual {{ p.name }} - {{ p.currency }} {{ formatNumber(p.real_price) }}
                                    </option>
                                </optgroup>
                            </select>
                        </div> 
                        <div class="d-flex w-100"> 
                            <button class="btn btn-secondary mx-auto m-2 mt-0 mb-0 d-inline-block w-50 p-0 pt-2 pb-2" @click="stepChangePlan = 0">Cancelar</button>
                            <div class="m-2 d-inline-block"></div>
                            <button class="btn btn-primary mx-auto m-2 mt-0 mb-0 d-inline-block w-50 p-0 pt-2 pb-2" @click="selectPlan(planSelected)">Seleccionar</button> 
                        </div>    
                    </div>
                </div>
                <div v-if="!selectPlanBool && daysFinishPlan < 5 && daysFinishPlan > 0">
                    <h5><b>Tu período de prueba finaliza en {{ daysFinishPlan }} días.<br>Selecciona el plan que mejor se adapte a ti</b></h5>
                    <div>
                        <h6>Seleccionar un plan</h6>
                        <div class="mb-3 col-sm-12">
                            <div class="input-group mb-3">
                                <select class="form-control form-control-lg text-center" id="plan" v-model="planSelected">
                                    <optgroup label="Mensuales">
                                        <option 
                                        v-for="p in plans.filter(pl => pl.duration == 30 && pl.plan_id != 4)" 
                                        :key="p.id" 
                                        :value="p.id">
                                        Plan mensual {{ p.name }} - {{ p.currency }} {{ formatNumber(p.real_price) }}
                                        </option>
                                    </optgroup>

                                    <optgroup label="Semestrales">
                                        <option 
                                        v-for="p in plans.filter(pl => pl.duration == 180 && pl.plan_id != 4)" 
                                        :key="p.id" 
                                        :value="p.id">
                                        Plan semestral {{ p.name }} - {{ p.currency }} {{ formatNumber(p.real_price) }}
                                        </option>
                                    </optgroup>

                                    <optgroup label="Anuales">
                                        <option 
                                        v-for="p in plans.filter(pl => pl.duration == 365 && pl.plan_id != 4)" 
                                        :key="p.id" 
                                        :value="p.id">
                                        Plan anual {{ p.name }} - {{ p.currency }} {{ formatNumber(p.real_price) }}
                                        </option>
                                    </optgroup>
                                </select>  
                            </div> 
                            <div class="d-flex w-100"> 
                                <button class="btn btn-secondary mx-auto m-2 mt-0 mb-0 d-inline-block w-50 p-0 pt-2 pb-2" @click="stepChangePlan = 0">Cancelar</button>
                                <div class="m-2 d-inline-block"></div>
                                <button class="btn btn-primary mx-auto m-2 mt-0 mb-0 d-inline-block w-50 p-0 pt-2 pb-2" @click="selectPlan(planSelected)">Seleccionar</button> 
                            </div>        
                        </div>
                    </div>
                </div>
                <div v-if="!selectPlanBool && daysFinishPlan == 0">
                    <h5><b>Tu período de prueba finaliza hoy.<br>Selecciona el plan que mejor se adapte a ti</b></h5>
                    <div>
                        <h6>Seleccionar un plan</h6>
                        <div class="mb-3 col-sm-12">
                            <div class="input-group mb-3">
                                <select class="form-control form-control-lg text-center" id="plan" v-model="planSelected">
                                    <optgroup label="Mensuales">
                                        <option 
                                        v-for="p in plans.filter(pl => pl.duration == 30 && pl.plan_id != 4)" 
                                        :key="p.id" 
                                        :value="p.id">
                                        Plan mensual {{ p.name }} - {{ p.currency }} {{ formatNumber(p.real_price) }}
                                        </option>
                                    </optgroup>

                                    <optgroup label="Semestrales">
                                        <option 
                                        v-for="p in plans.filter(pl => pl.duration == 180 && pl.plan_id != 4)" 
                                        :key="p.id" 
                                        :value="p.id">
                                        Plan semestral {{ p.name }} - {{ p.currency }} {{ formatNumber(p.real_price) }}
                                        </option>
                                    </optgroup>

                                    <optgroup label="Anuales">
                                        <option 
                                        v-for="p in plans.filter(pl => pl.duration == 365 && pl.plan_id != 4)" 
                                        :key="p.id" 
                                        :value="p.id">
                                        Plan anual {{ p.name }} - {{ p.currency }} {{ formatNumber(p.real_price) }}
                                        </option>
                                    </optgroup>
                                </select> 
                            </div> 
                            <div class="d-flex w-100"> 
                                <button class="btn btn-secondary mx-auto m-2 mt-0 mb-0 d-inline-block w-50 p-0 pt-2 pb-2" @click="stepChangePlan = 0">Cancelar</button>
                                <div class="m-2 d-inline-block"></div>
                                <button class="btn btn-primary mx-auto m-2 mt-0 mb-0 d-inline-block w-50 p-0 pt-2 pb-2" @click="selectPlan(planSelected)">Seleccionar</button> 
                            </div>    
                        </div>
                    </div>
                </div>  
            </div> 
            <section v-if="couponBool && userPlan == 4" class="text-center text-white fs-5 mt-2">
                <p>Además, finalizada la prueba tienes un {{couponDiscount}}% de descuento sobre tu plan por {{ couponMonth }} meses.</p>   
            </section>
        </div>
    </div>

    <!-- ends planes nuevo -->

    <div class="owl-stage-outer d-sm-block" id="planes" v-if="!compact">
        <div>
            <nav class="container-tabs position-relative position-sticky" style="z-index: 4; top:200px">
                <div class="tabs w-100">
                    <input type="radio" id="item1" name="tabs" v-model="viewModel" value="item1"/>
                    <label class="tab" for="item1" @click="changeView('item1')">Planes mensuales</label>
                    <input type="radio" id="item2" name="tabs" v-model="viewModel" value="item2"/>
                    <label class="tab" for="item2" @click="changeView('item2')">Planes semestrales</label>      
                    <input type="radio" id="item3" name="tabs" v-model="viewModel" value="item3"/>
                    <label class="tab" for="item3" @click="changeView('item3')">Planes anuales</label>      
                    <span class="glider"></span>
                </div>
            </nav>
        </div>
        <!-- planes mensuales -->
        <div class="owl-stage" v-if="viewModel == 'item1'">
            <div v-for="p in monthlyPlans" :key="p.id" class="owl-item active p-0">
                <div :class="planClasses[Number(p.plan_id)] || 'pricing-box-2 text-center'" :style="planStyles[Number(p.plan_id)] || {}">
                    <div class="text-primary fs-4 pt-2">
                        Plan mensual
                        <div class="pricing-title text-center">
                            {{ p.name }}
                        </div>
                    </div>
                    <div class="text-center p-2">
                        <p v-if="p.plan_id != 3" class="fs-6 lh-1" :class="planClassesText[Number(p.plan_id)]">Todas las funcionalidades menos talleres</p>
                        <p v-else class="fs-6 lh-1" :class="planClassesText[Number(p.plan_id)]">Todas las funcionalidades incluido talleres</p>
                        <p v-if="p.plan_id != 3" class="fs-6 lh-1" :class="planClassesText[Number(p.plan_id)]"><b>Hasta {{ p.uses }} turnos mensuales.</b></p>
                        <p v-else class="fs-6 lh-1" :class="planClassesText[Number(p.plan_id)]"><b>Turnos Ilimitados.</b></p>
                    </div> 
                    <div v-if="p.plan_id == 4" class="price-wrap"><span class="price">Gratis</span></div> 
                    <div v-else class="price-wrap"><span class="currency text-primary-2 fw-bold">{{p.currency}}</span><span class="price text-primary-2 fw-bold">{{formatNumber(p.real_price)}}</span><span class="currency text-primary-2 fw-bold">/mes</span></div>
                    <div>
                        <button v-if="userPlan == p.plan_id && p.duration == userPlanDuration" class="btn btn-outline-primary btn-lg" disabled>Seleccionado</button>
                        <button v-else class="btn btn-outline-primary btn-lg" @click="selectPlan(p.id)">
                            Seleccionar Plan {{ p.name }}
                        </button>
                    </div>
                </div>
            </div>     
        </div>
        <!-- planes semestrales -->
         <div class="alert alert-info text-center" v-if="viewModel == 'item2'">
            ¡Ahorras un 8,3% de descuento y el precio congelado por 6 meses! 
        </div>
        <div class="owl-stage" v-if="viewModel == 'item2'"> 
            <div v-for="p in semiAnnualPlans" :key="p.id" class="owl-item active p-0">
                <div :class="planClasses[Number(p.plan_id)] || 'pricing-box-2 text-center'" :style="planStyles[Number(p.plan_id)] || {}">
                    <div class="text-primary fs-4 pt-2">
                        Plan semestral
                        <div class="pricing-title text-center">
                            {{ p.name }}
                        </div>
                    </div>
                    <div class="text-center p-2">
                        <p v-if="p.plan_id != 3" class="fs-6 lh-1" :class="planClassesText[Number(p.plan_id)]">Todas las funcionalidades menos talleres</p>
                        <p v-else class="fs-6 lh-1" :class="planClassesText[Number(p.plan_id)]">Todas las funcionalidades incluido talleres</p>
                        <p v-if="p.plan_id != 3" class="fs-6 lh-1" :class="planClassesText[Number(p.plan_id)]"><b>Hasta {{ p.uses }} turnos mensuales.</b></p>
                        <p v-else class="fs-6 lh-1" :class="planClassesText[Number(p.plan_id)]"><b>Turnos Ilimitados.</b></p>
                    </div> 
                    <div v-if="p.plan_id == 4" class="price-wrap"><span class="price">Gratis</span></div> 
                    <div v-else class="price-wrap"><span class="currency text-primary-2 fw-bold">{{p.currency}}</span><span class="price text-primary-2 fw-bold">{{formatNumber(p.real_price)}}</span><span class="currency text-primary-2 fw-bold"> por 6 meses</span></div>
                    <div>
                        <button v-if="userPlan == p.plan_id && p.duration == userPlanDuration" class="btn btn-outline-primary btn-lg" disabled>Seleccionado</button>
                        <button v-else class="btn btn-outline-primary btn-lg" @click="selectPlan(p.id)">
                            Seleccionar Plan {{ p.name }}
                        </button>
                    </div>
                </div>
            </div>     
        </div>
        <!-- planes semestrales -->
         <div class="alert alert-info text-center" v-if="viewModel == 'item3'">
            ¡Abonás solo 11 meses y mantenés el precio congelado por 12!
        </div>
        <div class="owl-stage" v-if="viewModel == 'item3'"> 
            <div v-for="p in annualPlans" :key="p.id" class="owl-item active p-0">
                <div :class="planClasses[Number(p.plan_id)] || 'pricing-box-2 text-center'" :style="planStyles[Number(p.plan_id)] || {}">
                    <div class="text-primary fs-4 pt-2">
                        Plan anual
                        <div class="pricing-title text-center">
                            {{ p.name }}
                        </div>
                    </div>
                    <div class="text-center p-2">
                        <p v-if="p.plan_id != 3" class="fs-6 lh-1" :class="planClassesText[Number(p.plan_id)]">Todas las funcionalidades menos talleres</p>
                        <p v-else class="fs-6 lh-1" :class="planClassesText[Number(p.plan_id)]">Todas las funcionalidades incluido talleres</p>
                        <p v-if="p.plan_id != 3" class="fs-6 lh-1" :class="planClassesText[Number(p.plan_id)]"><b>Hasta {{ p.uses }} turnos mensuales.</b></p>
                        <p v-else class="fs-6 lh-1" :class="planClassesText[Number(p.plan_id)]"><b>Turnos Ilimitados.</b></p>
                    </div> 
                    <div v-if="p.plan_id == 4" class="price-wrap"><span class="price">Gratis</span></div> 
                    <div v-else class="price-wrap"><span class="currency text-primary-2 fw-bold">{{p.currency}}</span><span class="price text-primary-2 fw-bold">{{formatNumber(p.real_price)}}</span><span class="currency text-primary-2 fw-bold"> por 1 año</span></div>
                    <div>
                        <button v-if="userPlan == p.plan_id && p.duration == userPlanDuration" class="btn btn-outline-primary btn-lg" disabled>Seleccionado</button>
                        <button v-else class="btn btn-outline-primary btn-lg" @click="selectPlan(p.id)">
                            Seleccionar Plan {{ p.name }}
                        </button>
                    </div>
                </div>
            </div>     
        </div>

    </div>
</div>








<div class="text-center" v-if="this.isRegister"><small class="fst-italic mt-3 text-dark">*No se te pedirá ingresar una tarjeta de crédito o débito durante el período de prueba.</small></div>
<div class="modal fade" id="modal" tabindex="-1" aria-labelledby="" data-bs-backdrop="false" aria-hidden="true" ref="modalEle">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title"></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body text-dark">
                <div class="text-center"> 
                    <h6 class="text-primary mb-3"><i class="las la-bullhorn"></i> Estás por cambiar de plan</h6>
                    <p class="legend text-danger" v-if="planSelected == 4"><b>ATENCIÓN: Si cambias al Plan mensual 10 Gratis y tienes talleres creados y/o vendidos se perderán y NO podrás recuperarlos luego. También se eliminarán todas las publicaciones más recientes y solo quedarán las dos más antiguas.</b></p>     
                    <p v-html="message"></p>
                    <p><small v-html="messageProrrateo"></small></p>
                    <p>¿Confirmas el cambio de plan?</p>
                </div>           
            </div>    
            <div class="modal-footer"> 
                <div class="d-flex align-items-stretch align-items-md-center justify-content-between flex-wrap flex-md-nowrap flex-column flex-md-row w-100">
                    <button class="btn btn-secondary text-decoration-none text-white me-2 w-100" data-bs-dismiss="modal" aria-label="Close">                           
                        Cancelar
                    </button>
                    <button class="mt-2 mt-md-0 btn btn-primary text-decoration-none text-white w-100" @click="confirmSelectPlan()">                           
                        Aceptar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="modalGiftSessions" tabindex="-1" aria-labelledby="" aria-hidden="true" data-bs-backdrop="false" ref="modalEle3">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title"></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body text-dark">
                <div class="text-center"> 
                    <h6 class="text-primary mb-3"><i class="las la-bullhorn"></i> ¡Buenas Noticias!</h6>
                    <img src="@/assets/imgs/congratulations.webp" class="img-fluid w-25">
                    <p>¡Te habilitamos {{extraSessions}} turnos más a tu plan actual para que puedas seguir trabajando!</p> 
                </div>           
            </div>    
            <div class="modal-footer"> 
                <div>
                    <button class="btn btn-primary text-decoration-none text-white" data-bs-dismiss="modal" aria-label="Close">                           
                        Aceptar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="modalCard" tabindex="-1" aria-labelledby="" aria-hidden="true" data-bs-backdrop="false" ref="modalEle4">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title"></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body text-dark">   
                 
            </div>    
        </div>
    </div>
</div>
<div class="mx-auto position-fixed bottom-0 end-0 start-0 end-0 p-0 pt-3 pb-3" style="z-index: 11000; width: fit-content; margin-bottom: 50px;">
    <div id="toastcontainer" class="w-25">
    </div>
</div>
</template>
<script>
import axios from "axios";
import { Modal } from "bootstrap";
import { Toast } from 'bootstrap';
import paymmentPlans from '@/components/plans/paymment-plans.vue'
import cardFormMp from '@/components/plans/card-form-mp.vue'
import cardFormSt from '@/components/plans/card-form-st.vue'
var modal = "";
export default {
    props: ['isRegister', 'textBtn', 'compact'],
    components: {
        paymmentPlans,  
        cardFormMp,
        cardFormSt   
    }, 
    data(){
        return{
            planClasses: {
                1: "pricing-box-2 text-center",
                2: "pricing-box-2 active text-center",
                3: "pricing-box-2 bg-light-green text-center text-primary",
                4: "pricing-box-2 text-white text-center"
            },
            planClassesText: {
                1: "text-dark",
                2: "text-dark",
                3: "text-primary",
                4: "text-white"
            },
            planStyles: {
                4: { backgroundColor: "#00c7a2" }
            },
            viewModel: 'item1',
            errorText: '',
            toastColor: '',
            toastBg: '',
            toastNumber: 0,
            dataReceiver: '',
            userPlan: '',
            userCountry: '',
            userPlanDuration: 0,
            message: '',
            titleMessage: '',  
            planSelected: '',
            nextPayment: '',
            lastPayment: '',
            periodStartUser: '',
            periodEndUser: '',
            periodStartUserNext: '',
            selectPlanBool: false,
            daysFinishPlan: '',
            totalUses: '',
            planUses: '',
            blockUse: false,
            canSelectGift: false,
            extraSessions: 0,
            stepChangePlan: 0,
            plans: [],
            daysProrrateo: 0,
            messageProrrateo: '',
            daysActualMonth: 0,
            cardAdded: 0,
            userCountry: 0,
            couponBool: false,
            couponMonth: 0,
            couponDiscount: 0,
            couponFinishDate: '',   
            periodFree: false,
            freeTrialDays: '', 
            planPayDate: '0000-00-00',
            hideLoading: true,
            difPayPlan: null  
        }
    },
    name: 'pricing-table',
    computed: {
    monthlyPlans() {
      return this.plans.filter(p => p.duration === '30' && p.plan_id !== '4');
    },
    semiAnnualPlans() {
      return this.plans.filter(p => p.duration === '180' && p.plan_id !== '4');
    },
    annualPlans() {
      return this.plans.filter(p => p.duration === '365' && p.plan_id !== '4');
    }
  },
    mounted: function () {    
        if(!this.isRegister){    
            if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                this.dataReceiver = localStorage.getItem('corporativeIn');
            }else{
                this.dataReceiver = localStorage.getItem('token');
            }
            var data = JSON.parse(localStorage.getItem('userData'));   
            this.userPlan = data.userPlan;
            this.userPlanDuration = data.days_plan;
            if(this.userPlanDuration == '30'){
                this.viewModel = 'item1';
            }else if(this.userPlanDuration == '180'){
                this.viewModel = 'item2';
            }else if(this.userPlanDuration == '365'){
                this.viewModel = 'item3';
            }
            this.userCountry = data.userCountry; 
            this.lastPayment = data.userlastPayment;
            this.nextPayment = data.userNextPayment;
           this.findUserData();
        }else{
            if(this.$route.params.browserCountry == 'ar'){
                this.userCountry = 5;
            }else if(this.$route.params.browserCountry == 'cl'){
                this.userCountry = 81;
            }else if(this.$route.params.browserCountry == 'mx'){
                this.userCountry = 42;
            }else if(this.$route.params.browserCountry == 'es'){
                this.userCountry = 28;
            }else if(this.$route.params.browserCountry == 'pe'){
                this.userCountry = 89;
            }else if(this.$route.params.browserCountry == 'co'){
                this.userCountry = 82;
            }else if(this.$route.params.browserCountry == 'uy'){
                this.userCountry = 111;
            }else if(this.$route.params.browserCountry == 'br'){
                this.userCountry = 12;
            }else{
                this.userCountry = 55;
            }
            this.findPlans(); 
        }
        
        
    },
    beforeDestroy: function () {
       
    },
    methods:{  
        formatNumber(value) {
            if (!value) return "0";
            
            // Detectar formato según país
            let locale = "es-AR"; // por defecto argentino
            if (this.userCountry == 55) {
            locale = "en-US"; // formato americano
            }

            // Asegurarse de que sea número
            const number = Number(value);

            // Formatear
            return new Intl.NumberFormat(locale).format(number);
        },
        changeView(val){ 
            this.viewModel = val;    
        },
        async findUserData(){    
            this.cardAdded = '1';
            var payload = {
                action: 'find-user-data',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver, 
                userCountry: this.userCountry,      
            }           
            await axios.post('/index.php', payload).then(result => {
                this.hideLoading = false;
                if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                    var data = result.data;
                }else{
                    localStorage.setItem('userData', JSON.stringify(result.data)); 
                    var data = JSON.parse(localStorage.getItem('userData'));
                }
                if(!this.isRegister){
                    if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                        this.dataReceiver = localStorage.getItem('corporativeIn');
                    }else{
                        this.dataReceiver = localStorage.getItem('token');
                    }   
                    this.planPayDate = data.planPayDate;
                    this.userPlan = data.userPlan;
                    this.userPlanDuration = data.days_plan;
                    if(this.userPlanDuration == '30'){
                        this.viewModel = 'item1';
                    }else if(this.userPlanDuration == '180'){
                        this.viewModel = 'item2';
                    }else if(this.userPlanDuration == '365'){
                        this.viewModel = 'item3';
                    }
                    this.userCountry = data.userCountry;
                    this.lastPayment = data.userlastPayment;
                    this.nextPayment = data.userNextPayment;
                    this.periodStartUser = data.periodStartUser;
                    this.periodEndUser = data.periodFinishUser;
                    this.periodStartUserNext = data.periodStartNextUser;
                    this.selectPlanBool = data.selectPlan;
                    this.daysFinishPlan = data.daysFinishPlan;
                    this.totalUses = data.totalUses;
                    this.planUses = data.planUses;
                    this.blockUse =  data.blockUse;
                    this.canSelectGift = data.canSelectGift;
                    this.daysProrrateo = data.prorrateo;
                    this.daysActualMonth = data.daysMonth;
                    this.cardAdded = data.card_added;
                    this.couponBool = data.couponBool;
                    this.couponMonth = data.couponMonth;
                    this.couponDiscount = data.couponDiscount;
                    this.couponFinishDate = data.couponFinishDate;
                    this.freeTrialDays = Math.max(0, 30 - data.difDaysPeriodFree);
                    this.periodFree = data.periodFree;
                    this.difPayPlan = data.difPayPlan;
                }else{
                    if(this.$route.params.browserCountry == 'ar'){
                        this.userCountry = 5;
                    }else if(this.$route.params.browserCountry == 'cl'){
                        this.userCountry = 81;
                    }else if(this.$route.params.browserCountry == 'mx'){
                        this.userCountry = 42;
                    }else if(this.$route.params.browserCountry == 'es'){
                        this.userCountry = 28;
                    }else if(this.$route.params.browserCountry == 'pe'){
                        this.userCountry = 89;
                    }else if(this.$route.params.browserCountry == 'co'){
                        this.userCountry = 82;
                    }else if(this.$route.params.browserCountry == 'uy'){
                        this.userCountry = 111;
                    }else if(this.$route.params.browserCountry == 'br'){
                        this.userCountry = 12;
                    }else{
                        this.userCountry = 55;
                    }
                }
                this.findPlans(); 
            })
            .catch(error => {
               
            })     
        },
        async giftSessions(){
            var payload = {
                action: 'gift-sessions',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver, 
                userCountry: this.userCountry,     
            }       
            await axios.post('/index.php', payload).then(result => {
                if(result.data.status == '200'){ 
                    this.extraSessions = result.data.extra;   
                    var modalGiftSessions = new Modal(document.querySelector('#modalGiftSessions')); 
                    modalGiftSessions.show();   
                    this.findUserData();
                    if(this.compact){
                        this.showHidePlansOptions();
                    }
                }
                
            })
            .catch(error => {
               
            }) 
        },
        async findPlans(){  
            this.plans = [];
            modal = new Modal(document.querySelector('#modal'))        
            var payload = {
                action: 'find-plans',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver, 
                userCountry: this.userCountry, 
                showFree: 'YES',     
                isRegister: this.isRegister
            }       
            await axios.post('/index.php', payload).then(result => {
                this.plans = result.data;
                if(this.userPlan != 4){
                    const plan = this.plans.find(p => p.plan_id === this.userPlan);
                    if (plan) {
                        const nombre = plan.name;
                        var duration = '/mes.';
                        if(this.userPlanDuration == 180){
                            duration = ' semestral.<br><b class="text-green">¡Ahorras hasta un 10%!</b>';
                        }else if(this.userPlanDuration == 365){
                            duration = ' anual.<br><b class="text-green">¡Ahorras hasta un 20%!</b>';
                        }
                        // armar el mensaje
                        this.titleMessage = `Estás en el plan: <b>Plan ${nombre}</b> `+duration;
                        
                    }
                }else{
                    this.titleMessage = `Estás en el plan: <b>Plan Gratuito</b>/mes.`;
                }
            })
            .catch(error => {
               
            })     
        },
        selectPlan(planSel){
            this.planSelected = planSel;
            
            if(!this.isRegister){
                const plan = this.plans.find(p => p.id === this.planSelected);

                if (plan) {
                    const nombre = plan.name;
                    const precio = this.formatNumber(plan.real_price);
                    const moneda = plan.currency;
                    var duration = '/mes.';
                    if(plan.duration == 180){
                        duration = ' semestral.<br><b class="text-primary">¡Ahorras hasta un 10%!</b>';
                    }else if(plan.duration == 365){
                        duration = ' anual.<br><b class="text-primary">¡Ahorras hasta un 20%!</b>';
                    }
                    var endMessage = '';
                    if(plan.duration != 30){
                        endMessage = '<br><small>*Solo abonarás la diferencia si ya tienes un plan semestral o anual.<small>';
                    }
                    // armar el mensaje
                    this.message = `Plan seleccionado: <b>Plan ${nombre}</b> ${moneda} ${precio}`+duration+endMessage;
                    modal.show()	
                } 
            }else{   
                localStorage.setItem('registerPlan', planSel)
                this.$router.push({ name: 'register' });
            }

        },
        async confirmSelectPlan(){  
            var elems = document.querySelectorAll(".bad");
            [].forEach.call(elems, function(el) {
                el.classList.remove("bad");
            });
            this.errorText = '';        
            var payload = {
                action: 'change-plan',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver, 
                planSelected: this.planSelected,
                userCountry: this.userCountry,
                prorrateo: this.daysProrrateo
            }
            await axios.post('/index.php', payload).then(result => { 
                if(result.data.status == '200'){
                    localStorage.setItem('userData', JSON.stringify(result.data));
                    modal.hide()
                    this.errorText = 'Se ha actualizado tu plan.';
                    this.toastBg = 'bg-info';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }   
                    this.findUserData();
                    this.stepChangePlan = 0;
                    return;
                }else if(result.data.status == '400'){
                    if(result.data.error == 'E20'){
                        this.errorText = 'No puedes cambiar a un plan inferior hasta el próximo ciclo de facturación.';
                    }else if(result.data.error == 'E21'){
                        this.errorText = 'No puedes cambiar a un plan de mayor duración hasta que no finalice el período de tu plan actual.';
                    }else if(result.data.error == 'E22'){
                        this.errorText = 'No puedes cambiar a un plan inferior.';
                    }
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }   
                    return;
                }
                

            })
            .catch(error => {
               
            })     
        },
        showHidePlansOptions(){
            this.planSelected = this.userPlan;
            this.stepChangePlan = 0;
            this.$parent.showHidePlansOptions();
        }     
    }
  }
</script>
<style scoped>
.tabs{
    background-color: #fff !important;
    box-shadow: none;
}
.tab{
    border-radius: 19px;
}
.card-sms-plan{
    /*background-image: linear-gradient(180deg, #d0368a 0%, #708ad4 99%);*/
    margin: 0;
    padding: 0;
    padding-top: 20px;
    padding-bottom: 20px;
    border: none;
}
.pricing-table .pricing-box-2.sm-pricing-box {
    padding: 25px 15px;
    background-color: #f2f3f8;
    max-width: 370px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    /* padding: 25px 25px 20px; */
    border: 1px solid #ddd;
}
.pricing-table .pricing-box-2.sm-pricing-box .price-wrap .currency-old {
    font-size: 14px;
    line-height: 1;
    vertical-align: -webkit-baseline-middle;
    color: #8b8b8b;
}
.pricing-table .pricing-box-2.sm-pricing-box .price-wrap .price.old-price {
    display: inline;
    font-size: 26px !important;
    line-height: 1;
    text-decoration: line-through;
    color: #8b8b8b;
}
.pricing-table .pricing-box-2.sm-pricing-box .price-wrap .price.new-price {
    display: inline;
    font-size: 28px !important;
    line-height: 1;
}
.pricing-table .pricing-box-2.sm-pricing-box .price-legend {
    max-width: 100%;
    margin: auto;
    margin-bottom: 20px;
    color: #000;
    font-size: 15px;
    color: #5798ef;
}
.pricing-table .pricing-box-2.sm-pricing-box .pricing-title {
    font-size: 1.5em !important;
}
.pricing-table .legend{
    font-size: 11px;
    line-height: 12px;
    margin-top: 12px;
    font-style: italic;
}

.pricing-table .close-plans {
    position: absolute;
    top: 7px;
    right: 36px;
    width: 20px;
    height: 20px;
    font-size: 40px;
    min-width: 1px;
    z-index: 20000;
    color: #fff;
    cursor: pointer;
}
.w-fit-content{
    width: fit-content;
}

#planes .price-box-color-secondary,
#planes .price-box-color-primary,
#planes .price-box-color-dark{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border:solid transparent 1px;
}

.pricing-table .pricing-box-2.active{
    background-color: white!important;
}
.pricing-table .owl-stage{
    align-items: flex-start;
}

#planes button[class="btn btn-outline-primary btn-lg"],
#planes button[class="btn btn-primary btn-lg"][data-v-8013057c],
#planes button[class="btn btn-primary btn-lg"]{
    border-radius: 20px!important;
    margin-bottom: 20px;
    background-color: #4d5454!important;
}

section.planes-txt #planes .text-primary-1,
section.planes-txt #planes .text-primary-2,
section.planes-txt #planes .text-primary-3,
section.planes-txt #planes .text-primary-4{
    color:#4d5454!important;
    line-height: 1em;
}




main #planes .pricing-box-2 .text-primary{
    color: #004193!important;
}
main #planes{
    padding-top: 20px;
    text-align: center;
}

main #planes .price-box-color-secondary[data-v-8013057c][data-v-8013057c], main #planes .price-box-color-primary[data-v-8013057c][data-v-8013057c], main #planes [data-v-8013057c][data-v-8013057c].price-box-color-dark {
  background-color: transparent !important;
  color: #004193 !important;
}

main #planes .owl-stage div.owl-item.active:first-child .pricing-box-2 .price-box-color-secondary .bg-primary-1{
    color:white!important;
}

#planes .price-box-color-secondary[data-v-8013057c][data-v-8013057c],
#planes .price-box-color-primary[data-v-8013057c][data-v-8013057c]{
    background-color: transparent!important;
    color:#004193 !important;
}
#planes .pricing-title{
    color:#004193 !important;
    font-size: 2em!important;
}
#planes .pricing-box-2{
    border:solid 1px  #00c7a2 !important;
    border-radius: 10px!important;
    border-color:  #00c7a2!important;
}

#planes button[class="btn btn-outline-primary btn-lg"],
#planes button[class="btn btn-primary btn-lg"][data-v-8013057c]{
    border-radius: 20px!important;
    margin-bottom: 20px;
    background-color: #4d5454!important;
}
#planes button[class="btn btn-outline-primary btn-lg"]:hover, 
#planes button[class="btn btn-primary btn-lg"][data-v-8013057c]:hover{
    background-color: #004193 !important; 
    color: white!important;
}

#planes .text-primary-2,
#planes .text-primary-3,
#planes .text-primary-4{
    color:#4d5454!important;
}
#planes .bg-light-green{
    background-color: rgba(0, 199, 162,.1)!important;
}

#planes button[class="btn btn-outline-primary btn-lg"], 
#planes button[class="btn btn-primary btn-lg"] {
    display: block;
    border-radius: 20px!important;
    width: 230px!important;
    box-sizing: border-box;
    margin-bottom: 20px;
    background-color: #4d5454!important;
    font-size: 0.9em;
    font-weight: 400;
    text-align: center;
    padding: 10px 10px!important;
}
.pricing-table .pricing-box-2 .price-wrap > *, .pricing-table .pricing-box-2 .price-wrap .currency {
    font-size: 14px;
}
@media screen and (max-width: 720px) {
.pricing-table .owl-item {
    margin-bottom: 10px;
}
}
@media screen and (min-width: 720px) {
    .pricing-table .owl-item {
        margin: 10px;
    }
}
.tabs .tab {        
    line-height: 0.9em;
    font-size: 1em;
}
</style>